import type { RouteStopType } from '@/types';

const getSecondStop = (
  filteredStops: RouteStopType[],
  remainingStops: RouteStopType[],
  isMoving: boolean
) => {
  if (filteredStops.length === 0) {
    return remainingStops.at(-1);
  }

  if (isMoving) {
    return filteredStops[0];
  }

  return filteredStops[1] ?? filteredStops[0];
};

export default getSecondStop;
